var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShevron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.99902C0 4.48002 4.48 -0.000976562 10 -0.000976562C15.53 -0.000976562 20 4.48002 20 9.99902C20 15.52 15.53 19.999 10 19.999C4.48 19.999 0 15.52 0 9.99902ZM9.43 12.9898L14.18 8.23976C14.52 7.89976 14.52 7.34976 14.18 6.99976C13.84 6.65976 13.28 6.65976 12.94 6.99976L8.81 11.1298L7.06 9.37976C6.72 9.03976 6.16 9.03976 5.82 9.37976C5.48 9.71976 5.48 10.2698 5.82 10.6198L8.2 12.9898C8.37 13.1598 8.59 13.2398 8.81 13.2398C9.04 13.2398 9.26 13.1598 9.43 12.9898Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10,
    y1: -0.000976563,
    x2: 10,
    y2: 19.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ECDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B8E86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShevron);
export default __webpack_public_path__ + "static/media/shevron.5f63b9bc960370cce8c2fdd809378502.svg";
export { ForwardRef as ReactComponent };